var _rect, _rect2, _rect3, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 40,
    width: 12,
    height: 16,
    rx: 2.5,
    fill: "#f2a2c4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 28,
    width: 12,
    height: 28,
    rx: 2.5,
    fill: "#73c5c7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 16,
    width: 12,
    height: 40,
    rx: 2.5,
    fill: "#f2a2c4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 36 L30 24 L46 14",
    stroke: "#1a1a1a",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 14 H38 M46 14 V22",
    stroke: "#73c5c7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartUp);
export default __webpack_public_path__ + "static/media/chart-up.7dd5b65cef48022e007c2da41e925412.svg";
export { ForwardRef as ReactComponent };